<template>
  <div :class="['tmallBox', { inApp: $root.$data.isApp }]">
    <common-title titleName="激活中心" :bcColor="'none'" :zIndex="1000"></common-title>
    <MemberActive />
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import MemberActive from './component/memberActive.vue';

export default {
  components: {
    CommonTitle,
    MemberActive,
  },
  data() {
    return {
    };
  },

  computed: {},
  mounted() {},

  methods: {
  },
};
</script>

<style lang="scss" scoped>
.tmallBox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  padding-top: 170px;
  padding-bottom: 100px;
  background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/mine/tmall-bg.png') no-repeat;
  background-size: 100%;
  &.inApp {
    padding-top: 80px;
    padding-bottom: 0;
  }
  .activeType {
    display: flex;
    justify-content: space-between;
    width: 670px;
    height: 80px;
    margin: 0 auto 24px;
    line-height: 80px;
    background: #fff;
    border-radius: 20px;
    dd {
      position: relative;
      width: 50%;
      color: #333;
      font-weight: 400;
      font-size: 28px;
      text-align: center;
      span {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        display: block;
        width: 50px;
        height: 6px;
        margin: 0 auto;
        background-color: #ff6c02;
        border-radius: 10px;
        visibility: hidden;
      }
    }
    dd:first-child::after {
      position: absolute;
      top: 20px;
      right: -10px;
      display: block;
      clear: both;
      width: 2px;
      height: 40px;
      background-color: #f6f6f6;
      content: '';
    }
    .memberActive {
      span {
        visibility: visible;
      }
    }
  }
  ::v-deep .commonTitle {
    .titleName {
      color: #fff;
      font-size: 40px;
    }
    .backButton {
      width: 44px;
      height: 48px;
      background: url('../../../assets/img/personalCenter/tmall-back.png') no-repeat;
      background-size: 100%;
    }
  }
  .from_content {
    width: 670px;
    margin: 0 auto;
    padding: 64px 60px 120px 60px;
    background: #fff;
    border-radius: 24px;
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.06);
    .step1 {
      > h2 {
        margin-bottom: 32px;
        color: #333;
        font-weight: 500;
        font-size: 32px;
      }
      .channel {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        width: 550px;
        height: 120px;
        margin: 24px auto;
        padding: 0 32px;
        background: #f8f9fb;
        border-radius: 20px;
        .channel-left {
          display: flex;
          align-items: center;
          justify-content: space-between;
          img {
            width: 72px;
            height: 72px;
            margin-right: 24px;
          }
          span {
            color: #333;
            font-weight: 500;
            font-size: 28px;
          }
        }
        > img {
          width: 40px;
          height: 40px;
        }
      }
    }
    .step2 {
      padding-top: 32px;
      > h2 {
        margin-bottom: 32px;
        color: #333;
        font-weight: 500;
        font-size: 32px;
      }
      > h3 {
        padding-top: 16px;
        color: #fc7e36;
        font-weight: 400;
        font-size: 24px;
        line-height: 34px;
      }
    }
    ::v-deep .van-cell {
      padding: 0;
      .van-field__body {
        .van-field__control {
          width: 275px;
          height: 60px;
          padding-left: 16px;
          color: #333;
          font-weight: 400;
          font-size: 14px;
          background: #f8f9fb;
          border-radius: 10px;
        }
        input::-webkit-input-placeholder {
          color: #a5a5a5;
        }
      }
    }
  }
  .tmallBtn {
    position: fixed;
    right: 0;
    bottom: 100px;
    left: 0;
    width: 622px;
    height: 100px;
    margin: 0 auto;
    color: #fff;
    font-size: 32px;
    line-height: 100px;
    text-align: center;
    background: #ff7f41;
    background: #ff6c02;
    border-radius: 16px;
    opacity: 0.5;
  }
  .tmallBtn.active {
    opacity: 1;
  }
}
</style>
